import type { ReactElement, ReactNode } from 'react';
import type { MediaDto } from '@gr/core/content/media/dto';
import styles from './MediaGrid.module.scss';

export interface MediaGridProps {
  label: string;
  items: readonly MediaDto[];
  /** Содержимое плитки: ссылка в библиотеке, флажок в выборе для поста. */
  renderItem(media: MediaDto): ReactNode;
}

/** Сетка медиа: две колонки на телефоне, дальше — сколько поместится (MED-UC-2). */
export function MediaGrid({ label, items, renderItem }: MediaGridProps): ReactElement {
  return (
    <ul className={styles.grid} aria-label={label}>
      {items.map((media) => (
        <li key={media.id} className={styles.cell}>
          {renderItem(media)}
        </li>
      ))}
    </ul>
  );
}
